import { useCallback, useState } from 'react';

import {
  MODAL_TYPES,
  ModalControls,
  UsePaymentModalsManagerResult
} from '@/components/AdvertisePayments/hooks/types';

export const usePaymentModalsManager = (): UsePaymentModalsManagerResult => {
  const [openModal, setOpenModal] = useState<MODAL_TYPES | null>(null);

  const isOpen = useCallback(
    (modal: MODAL_TYPES) => openModal === modal,
    [openModal]
  );

  const open = useCallback((modal: MODAL_TYPES) => setOpenModal(modal), []);
  const close = useCallback(() => setOpenModal(null), []);

  const modalsBuildControls = (modal: MODAL_TYPES): ModalControls => ({
    isOpen: isOpen(modal),
    open: () => open(modal),
    close
  });

  return {
    isAnotherModal: openModal !== null,
    closeAll: close,
    success: modalsBuildControls(MODAL_TYPES.SUCCESS),
    successTopUp: modalsBuildControls(MODAL_TYPES.SUCCESS_TOP_UP),
    error: modalsBuildControls(MODAL_TYPES.ERROR),
    errorTopUp: modalsBuildControls(MODAL_TYPES.ERROR_TOP_UP),
    failed: modalsBuildControls(MODAL_TYPES.FAILED),
    emptyBalance: modalsBuildControls(MODAL_TYPES.EMPTY_BALANCE)
  };
};
